import { createStore, compose, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";

import sagas from "./sagas";
import reducers from "./ducks";

const middlewares = [];

const sagaMonitor =
  process.env.NODE_ENV === "development"
    ? console.tron.createSagaMonitor()
    : null;
const sagaMiddleware = createSagaMiddleware({ sagaMonitor });

middlewares.push(sagaMiddleware);

const createAppropriateStore =
  process.env.NODE_ENV === "development"
    ? console.tron.createStore
    : createStore;

export const history = createBrowserHistory();

const rootReduces = connectRouter(history)(reducers);

middlewares.push(routerMiddleware(history));

const store = createAppropriateStore(
  rootReduces,
  compose(applyMiddleware(...middlewares))
);

sagaMiddleware.run(sagas);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js